module.exports = __webpack_public_path__ + "static/media/008-Heart and Crown.cb063fb0.png";